import React from 'react';
import Root  from './pages/Root';
import './App.css';

function App() {
  return (
    <Root/>
  );
}

export default App;





/**
 * 
 * 
 *   
 * 
       "homepage": "https://www.yisumatica.org.il/flash-upload/pisa-math",

 */